import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Box, Checkbox, FormControlLabel, IconButton, Tooltip } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    iframe: {
        height: 700,
        width: '100%',
        border: '1px solid #ccc',
    },
    saveCard: {
        marginRight: 0,
    },
    saveCardInfo: {
        padding: 8,
    },
})

class NuveiFrame extends React.Component {
    iframeRef = React.createRef()

    state = {
        iframeUrl: this.generateIframeUrl(),
        paymentSaveCard: this.props.paymentSaveCard,
    }

    componentDidMount() {
        window.addEventListener('message', this.handlePostMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handlePostMessage)
    }

    generateIframeUrl() {
        const urlParams = new URLSearchParams({
            params: JSON.stringify({ // using JSON allows for nesting and removes undefineds
                store_id: this.props.store.id,
                name: this.props.billTo?.name,
                email: this.props.billTo?.email,
            }),
        })

        return `${this.props.processorSettings.iframe}?${urlParams}`
    }

    handlePostMessage = async (event) => {
        const { paymentSaveCard } = this.state
        const { source, data } = event

        try {
            if (source != this.iframeRef.current.contentWindow || data.wylie_script != 'q2pm') {
                return // not from our iframe & script
            }
        } catch {
            return // fallback in case the check above causes an issue itself
        }

        // console.log(data)

        try {
            this.props.onTokenize(data.CARDREFERENCE, data.CARDEXPIRY, data.MASKEDCARDNUMBER.substr(-4), data.CARDTYPE, null, paymentSaveCard)

        } catch (err) {
            this.props.showError(err)

            // re-render the iframe
            try {
                this.setState({
                    iframeUrl: this.generateIframeUrl(),
                })
            } catch (err) {
                this.props.showError(err)
            }
        }
    }

    handlePaymentSaveChange = () => {
        const { paymentSaveCard } = this.state

        this.setState({
            paymentSaveCard: !paymentSaveCard,
        })
    }

    render() {
        const { className, classes, forceSaveCard, saveCardLabel } = this.props
        const { iframeUrl, paymentSaveCard } = this.state

        return (
            <Box className={className}>
                <iframe
                    ref={this.iframeRef}
                    className={classes.iframe}
                    src={iframeUrl}
                    frameBorder="0"
                    scrolling="yes"
                ></iframe>
                <br />
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved.">
                    <FormControlLabel
                        className={classes.saveCard}
                        disabled={forceSaveCard}
                        control={
                            <Checkbox
                                color="primary"
                                checked={paymentSaveCard}
                                onClick={this.handlePaymentSaveChange}
                            />
                        }
                        label={saveCardLabel || 'Save card on file (secure)'}
                    />
                </Tooltip>
                <Tooltip disableInteractive arrow title="Cards are securely stored as encrypted tokens. Your actual card number is never saved." enterTouchDelay={0} leaveTouchDelay={10000}>
                    <IconButton className={classes.saveCardInfo} size="large">
                        <HelpOutlineIcon />
                    </IconButton>
                </Tooltip><br />
            </Box>
        )
    }
}

export default withAppContext(withStyles(styles, { withTheme: true })(NuveiFrame))
